import * as React from "react";
import BMGLayoutComponent from "../../components/layout/bmg-layout.component";
import FaceValidationComponent from "./../face-validation/face-validation.component";
import { GetCliente } from "./../../services/cliente.service";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './home.css';

interface HomeComponentState {
  initialValidacao: boolean;
  nomeCliente: string;
  dataNascimentoCliente: string;
  cpfCliente: string;
}

export default class HomeComponent extends React.Component<{}, HomeComponentState> {

  constructor(props: {}) {
    super(props);
    this.state = {
      initialValidacao: false,
      nomeCliente: "",
      dataNascimentoCliente: "",
      cpfCliente: ""
    };
  }

  componentDidMount() {

    this.getUser();
  }

  async getUser() {
    const response = await GetCliente();
    const nome = response.nome;
    const data = response.dataNascimento;
    const cpf = response.cpf;
    this.setState(
      {
        initialValidacao: false,
        nomeCliente: nome,
        dataNascimentoCliente: data,
        cpfCliente: cpf
      }
    );
  }


 
  handleRedirectValidacao() {
    this.setState({ initialValidacao: true });
  }

  render() {
    const { initialValidacao, nomeCliente, dataNascimentoCliente, cpfCliente } = this.state;
    if (initialValidacao) return <FaceValidationComponent />
    return (
      <div>
        <BMGLayoutComponent />
        <div className="home">
          <div className="carousel-content">
            <div className="slider-content">
              <Slider dots={true}>
                <div>
                  <div className="carousel-text">
                    <p>{`Olá ${nomeCliente}, tudo bem?`}</p>
                    <p className="text-bold"> Vamos validar <b className="text-bold-color">sua identidade</b> para garantir sua segurança. Veja algumas dicas para a selfie!</p>
                  </div>

                  <div className="carousel-img-content">
                    <img src="src/assets/images/carousel-01.png" className="carousel-img" alt="Imagem 1" />
                  </div>
                </div>
                <div>
                  <div className="carousel-text">
                  <br></br>
                    <p>Na mensagem de acesso a câmera, <b className="text-bold">clique em PERMITIR.</b></p>
                  </div>
                  <div className="carousel-img-content">
                    <img src="src/assets/images/carousel-02.png" className="carousel-img" alt="Imagem 2" />
                  </div>
                </div>
                <div>
                  <div className="carousel-text">
                    <br></br>
                    <p> Esteja sozinho e posicione o celular na altura dos seus olhos.</p>
                  </div>
                  <div className="carousel-img-content">
                    <img src="src/assets/images/carousel-03.png" className="carousel-img" alt="Imagem 3" />
                  </div>
                </div>
                <div>
                  <div className="carousel-text">
                  <br></br>
                  <br></br>
                    Escolha um local bem iluminado.
                  </div>
                  <div className="carousel-img-content">
                    <img src="src/assets/images/carousel-04.png" className="carousel-img" alt="Imagem 4" />
                  </div>
                </div>
                <div>
                  <div className="carousel-text">
                  <br></br>
                  <br></br>
                    Não use chapéu ou boné
                  </div>
                  <div className="carousel-img-content">
                    <img src="src/assets/images/carousel-05.png" className="carousel-img" alt="Imagem 5" />
                  </div>
                </div>
                <div>
                  <div className="carousel-text">
                  <br></br>
                  <br></br>
                    Não use óculos de sol e se tiver óculos de grau tire pra foto.
                  </div>
                  <div className="carousel-img-content">
                    <img src="src/assets/images/carousel-06.png" className="carousel-img" alt="Imagem 6" />
                  </div>
                </div>
              </Slider>
            </div>
          </div>
          <button className="button-primario" onClick={() => this.handleRedirectValidacao()}>Começar Validação</button>
          <div className="dados-pessoais-content">
            <p className="left">Dados Pessoais:</p>
            <div className="dados-pessoais">
              <div className="row-dados-pessoais">
                <div className="dados-pessoais-image">
                  <img src="src/assets/images/user.png" className="image" />
                </div>
                <div className="dados-pessoais-description">
                  <label className="descripton-caption">Data nascimento</label>
                  <p className="descripton-text">{dataNascimentoCliente}</p>
                </div>
              </div>
              <div className="row-dados-pessoais">
                <div className="dados-pessoais-image">
                  <img src="src/assets/images/user-details.png" className="image" />
                </div>
                <div className="dados-pessoais-description">
                  <label className="descripton-caption">CPF</label>
                  <p className="descripton-text">{cpfCliente}</p>
                </div>
              </div>
              <div className="separador"></div>
              <div className="termos">
                <a href="#">Termos e Condições</a>
              </div>
            </div>

          </div>
          <div className="footer-text">
            <p className="text-footer">Para garantirmos a segurança e atender a sua solicitação na central de atendimento vamos validar a sua identidade através de uma foto.</p>
            <p className="text-footer">Não esqueça de dar uma olhada nas dicas para saber a melhor forma para capturar a sua imagem e realizar a validação via foto.</p>

          </div>
        </div>


      </div>
    );
  }
}